import React, { useEffect, useState } from 'react'
import { IUserStatisticData } from '../../../types/types'
import { ChartData } from 'chart.js'
import PieChart from '@professocial/professocialChartComponents/ChartComponents/PieChart'

const PostingPieChart: React.FC<IUserStatisticData> = (props) => {
  const [chartData, setChartData] = useState<ChartData | undefined>(props.data)

  useEffect(() => {
    props.data && createChartData(props.data)
  }, [props.data])

  const createChartData = (statisticsObj: ChartData) => {
    if (statisticsObj.datasets && statisticsObj.datasets.length > 0) {
      setChartData({
        labels: statisticsObj.labels,
        datasets: statisticsObj.datasets.map((dataset, index: number) => {
          return ({
            label: dataset.label,
            data: dataset.data,
            backgroundColor: props.colors,
          })
        }),
      })
    }
  }

  return (
    <div style={{ position: 'relative', margin: 'auto', height: '400px', width: '95%' }}>
      <PieChart
        type='pie'
        data={chartData as ChartData<'pie'>}
        height={125}
        options={{
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            legend: {
              position: 'left',
              labels: {
                boxWidth: 25
              }
            },
          }
        }}
      />
    </div>
  )
}
export default PostingPieChart
